import { styled } from 'styled-components'
import { m } from 'motion/react'
import { type CSSProperties } from 'react'

export const Container = styled(m.div)`
  width: 100%;
  position: relative;
  min-height: 100px;
`

export const VideoHydrateRoot = styled.div`
  width: 100%;
  height: 100%;
  z-index: 1;
  background-position: 50%;
  margin: auto;
  position: absolute;
  top: -100%;
  bottom: -100%;
  left: -100%;
  right: -100%;
`

export const Video = styled.video`
  width: 100%;
  height: calc(100% + 2px);
  z-index: 1;
  background-position: 50%;
  margin: auto;
  position: absolute;
  top: -100%;
  bottom: -100%;
  left: -100%;
  right: -100%;
  object-fit: cover;
`

type VideoProps = {
  $fit?: 'cover' | 'contain' | 'fill'
  $position: CSSProperties['objectPosition']
}

export const ChildrenContainer = styled.div`
  position: absolute;
  z-index: 3;
  inset: 0;
`

export const Poster = styled.img<VideoProps & { $autoPlay: boolean }>`
  width: 100%;
  height: 100%;
  object-fit: ${({ $fit }) => $fit || 'cover'};
  object-position: ${({ $position = 'unset' }) => $position};
  z-index: ${({ $autoPlay }) => ($autoPlay ? 0 : 2)};
  background-position: 50%;
  margin: auto;
  position: absolute;
  top: -100%;
  bottom: -100%;
  left: -100%;
  right: -100%;
`
